module.exports = __webpack_public_path__ + "img/footer.0ddb58d1.png";